import React, { useEffect, useState } from 'react';
import { useSearchParams,Link } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faUser  } from '@fortawesome/free-solid-svg-icons';


const VerifyEmail = () => {
  const [status, setStatus] = useState('Verifying...');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verify = async () => {
      const token = searchParams.get('token');
      const email = searchParams.get('email');

      if (!token || !email) {
        setStatus('Invalid verification link.');
        return;
      }

      try {
        const response = await axios.get(`/api/verify-email?token=${token}&email=${email}`);
        if (response.status === 200) {
          setStatus(response.data.message );
        } else {
          setStatus('Verification failed.');
        }
      } catch (error) {
        setStatus('Verification failed or link expired.');
      }
    };

    verify();
  }, [searchParams]);

  return (
    <div>
     <section className="contact"> 
    <div style={{ padding: 20 }}>
     <h1>Welcome to VolleyTally!</h1>
     <br/>
      <h2>Email Verification</h2>
       <br/>
      <p>{status}</p>
     
    </div>
    </section>

     <br/>
      <Link to={`/auth/login`} className="header-button">
                  <FontAwesomeIcon icon={faUser} /> &nbsp; Login
                </Link>
      <br/>

  </div>
  );
};

export default VerifyEmail;
